import { Component, OnInit, Host } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { PointsOfInterestService } from "./pointsofinterest.service";
import { BaseDatatableComponent, IDataTableParameters, AlertService, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { PointOfInterest } from "../../api-models/PointOfInterest";
import { PointsOfInterestMainComponent } from "./pointsofinterest.main.component";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";

@Component({
    selector: "app-pointsofinterest",
    templateUrl: "./pointsofinterest.component.html",
    styleUrls: ["pointsofinterest.component.scss"]
})
export class PointsOfInterestComponent extends BaseDatatableComponent implements OnInit {
    public UTCDATEFORMAT = "";

    rows: PointOfInterest[] = [];

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly pointsOfInterestService: PointsOfInterestService,
        private readonly modalService: BsModalService,
        private readonly alertService: AlertService,
        private readonly translateService: TranslateService,
        @Host() parent: PointsOfInterestMainComponent
    ) {
        super(translateService, {
            stateSaveMode: pointsOfInterestService.datatableStateSaveMode,
            stateSaveComponent: parent,
            stateSaveStorageKey: "dtstate_pointsofinterest_list"
        });

        this.dtOptions.order = [[4, "desc"]];
        this.UTCDATEFORMAT = this.pointsOfInterestService.UTCDATEFORMAT;
    }

    ngOnInit() {}

    _dataTableTrigger() {
        return (dataTableParameters: IDataTableParameters, callback) => {
            // get api query parameters by datatable
            const queryParams = this.getApiQueryParamsByDataTable(dataTableParameters);

            this.subscriptions.push(
                this.pointsOfInterestService.list(queryParams).subscribe((result) => {
                    this.rows = result.list;

                    callback({
                        recordsTotal: result.total,
                        recordsFiltered: result.count,
                        data: []
                    });
                })
            );
        };
    }

    _dataTableColums() {
        return [
            { data: "name", orderable: true },
            { data: "postalcode", orderable: true },
            { data: "city", orderable: true },
            { data: "country", orderable: true },
            { data: "created", orderable: true },
            { data: "updated", orderable: true },
            { data: "actions", orderable: false }
        ];
    }

    add() {
        this.router.navigate(["add"], { relativeTo: this.route });
    }

    edit(id: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }

    delete(id: string) {
        const initialState = {
            title: this.translateService.instant("pointsofinterest.list.delete.title"),
            message: this.translateService.instant("pointsofinterest.list.delete.message"),
            closeBtnName: this.translateService.instant("global.buttons.close"),
            confirmBtnName: this.translateService.instant("global.buttons.ok")
        };
        const bsModalRef = this.modalService.show(ConfirmDialogComponent, { initialState });
        bsModalRef.content.confirmCallback = () => {
            this.subscriptions.push(
                this.pointsOfInterestService.delete(id).subscribe((result) => {
                    this.alertService.addSuccess(this.translateService.instant("pointsofinterest.list.delete.success"));
                    this.rerenderDatatable();
                })
            );
        };
    }
}
